import React from "react";
import PropTypes from "prop-types";
import { images } from "../../../assets";
import classes from "./emptystate.module.css";

const Emptystate = ({ name, styleClass }) => {
   return (
      <div className={`${classes.subsidiaryList} ${styleClass ?? ""}`}>
         <div className={classes.image}>
            <img src={images.noRecord} alt="" />
         </div>
         <p>No results found</p>
         <span>
            Please create a new {name} to see the list {""}
            <b>populated</b> here
         </span>
      </div>
   );
};

Emptystate.propTypes = {
   name: PropTypes.string,
   styleClass: PropTypes.string,
};

export default Emptystate;
